package org.dronda.lib.validation.rules

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import org.dronda.lib.validation.ValidationError

data class RegexMatchFailed(val value: String) : ValidationError()

data class InvalidUrl(val value: String) : ValidationError()

fun regex(value: String, regex: Regex): Result<String, ValidationError> {
    return if (regex.matches(value)) {
        Ok(value)
    } else {
        Err(RegexMatchFailed(value))
    }
}

private val urlRegex = """^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?${'$'}""".toRegex()
fun url(value: String): Result<String, ValidationError> {
    return if (urlRegex.matches(value)) {
        Ok(value)
    } else {
        Err(InvalidUrl(value))
    }
}
